import { LayoutConst } from 'core';
import { ProjectDelegate } from 'project-delegate';
import React, { BaseSyntheticEvent, useMemo, useState } from 'react';
// @ts-ignore
import GridLayout, { Layout } from 'react-grid-layout';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import './styles.css';
import { useBreakpoint } from '@brg/ui';

interface GridLayoutComponentProps {
    layout: Layout[];
    onLayoutChange: (layout: Layout[]) => void;
    cols: number,
    rowHeight: number,
    padding?: number,
    width?: number
}

const GridWithDifferentSizes: React.FC<GridLayoutComponentProps> = ({ layout, onLayoutChange, cols, rowHeight, padding, width }) => {
    const [isDragged, setIsDragged] = useState(false);
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

    //костыль для корректной работы двухуровневого тултипа
    const onItemMouseMove = (ev: BaseSyntheticEvent) => {
        if (ev.currentTarget) {
            ev.currentTarget.style.zIndex = 2
        }
    }
    const onItemMouseLeave= (ev: BaseSyntheticEvent) => {
        if (ev.currentTarget) {
            ev.currentTarget.style.zIndex = 1
        }
    }

    const items = useMemo(() => (layout.map((item, idx) => (
        <div 
            onMouseEnter={onItemMouseMove} 
            onMouseLeave={onItemMouseLeave} 
            className='drag-container' 
            data-grid={{ x: item.x, y: item.y, w: item.w, h: item.h }} 
            key={item.i}
        >
            <div className='js-drag-item' />
            {/* @ts-ignore */}
            <ProjectCardNew
                project={item?.project as any}
                isEditable={item?.project?.isEditable}
                isCanNotBeDraft
                isRejected={ProjectDelegate.isRejectedProject(item?.project)}
                key={(item?.project?.projectId || '') + idx}
                {...computeProject(item?.project)}
                placement={'bottom-start'}
            />
        </div>
      ))) , [layout, isDragged])

  return (
    <GridLayout
        className="layout"
        layout={layout}
        autoSize
        isResizable={false}
        width={width}
        onDragStop={(items: any) => {
            onLayoutChange(items);
            setIsDragged(false)
        }}
        rowHeight={rowHeight}
        draggableHandle='.js-drag-item'
        compactType={'horizontal'}
        margin={[padding, padding]}
        containerPadding={[0,0]}
        cols={cols}
    >
      {items}
    </GridLayout>
  );
};

export default GridWithDifferentSizes;import { LayoutConst } from 'core';
import { ProjectDelegate } from 'project-delegate';
import React, { BaseSyntheticEvent, useMemo, useState } from 'react';
// @ts-ignore
import GridLayout, { Layout } from 'react-grid-layout';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { computeProject } from 'shared/helpers/types/computed/ComputedProject';
import './styles.css';
import { useBreakpoint } from '@brg/ui';

interface GridLayoutComponentProps {
    layout: Layout[];
    onLayoutChange: (layout: Layout[]) => void;
    cols: number,
    rowHeight: number,
    padding?: number,
    width?: number
}

const GridWithDifferentSizes: React.FC<GridLayoutComponentProps> = ({ layout, onLayoutChange, cols, rowHeight, padding, width }) => {
    const [isDragged, setIsDragged] = useState(false);
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

    //костыль для корректной работы двухуровневого тултипа
    const onItemMouseMove = (ev: BaseSyntheticEvent) => {
        if (ev.currentTarget) {
            ev.currentTarget.style.zIndex = 2
        }
    }
    const onItemMouseLeave= (ev: BaseSyntheticEvent) => {
        if (ev.currentTarget) {
            ev.currentTarget.style.zIndex = 1
        }
    }

    const items = useMemo(() => (layout.map((item, idx) => (
        <div 
            onMouseEnter={onItemMouseMove} 
            onMouseLeave={onItemMouseLeave} 
            className='drag-container' 
            data-grid={{ x: item.x, y: item.y, w: item.w, h: item.h }} 
            key={item.i}
        >
            <div className='js-drag-item' />
            {/* @ts-ignore */}
            <ProjectCardNew
                project={item?.project as any}
                isEditable={item?.project?.isEditable}
                isCanNotBeDraft
                isRejected={ProjectDelegate.isRejectedProject(item?.project)}
                key={(item?.project?.projectId || '') + idx}
                {...computeProject(item?.project)}
                placement={'bottom-start'}
            />
        </div>
      ))) , [layout, isDragged])

  return (
    <GridLayout
        className="layout"
        layout={layout}
        autoSize
        isResizable={false}
        width={width}
        onDragStop={(items: any) => {
            onLayoutChange(items);
            setIsDragged(false)
        }}
        rowHeight={rowHeight}
        draggableHandle='.js-drag-item'
        compactType={'horizontal'}
        margin={[padding, padding]}
        containerPadding={[0,0]}
        cols={cols}
    >
      {items}
    </GridLayout>
  );
};

export default GridWithDifferentSizes;